import React, { useRef } from "react";
import styled from "styled-components";
import _ from "lodash";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import Link from "@airasia/phoenix-components/components/Link"
import Slider from "react-slick";
import {useTheme} from "@material-ui/core"




var StyledFaChevronRight = styled(FaChevronRight)`
  position: absolute;
  top: 0;
  z-index: 2;
  right: -20px;
  background-color: white;
  height: 100%;
  color: red;
  @media screen and (max-width: 1020px) {
    right: 0px;
  }
`
var StyledFaChevronLeft = styled(FaChevronLeft)`
  position: absolute;
  top: 0;
  z-index: 2;
  left: -20px;
  background-color: white;
  height: 100%;
  color: red;
  @media screen and (max-width: 1020px) {
    left: 0px;
  }
`

const PanelWrapper = styled.div`
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 16px;
    .slick-track .slick-slide{
        box-sizing: border-box;
    }
    .slick-track .slick-slide:first-child{
        padding-right: 8px;
        padding-left: 4px;
        // border: 1px solid red;
    }
    .slick-track .slick-slide:not(:first-child):not(:last-child){
        padding-left: 8px;
        padding-right: 8px;
        // border: 1px solid green;
    }
    .slick-track .slick-slide:last-child{
        padding-left: 8px;
        // border: 1px solid blue;
    }
`;

const CardWrapper = styled.div`
    // border: 1px solid black;
    height: 40px;
    min-width: 300px;
    max-width: 600px;
    padding-block: 4px;
    width: ${props => `${props.panelWidth}px` || '123px'};
    flex-shrink: 0;
`;

const getCardWrapperWidth = (panelRef, dividedBy = 3) => {
    if (_.isEmpty(panelRef)) {
        return 300
    } else {
        return Math.floor((panelRef.clientWidth / dividedBy) - 8)
    }
}

function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return <StyledFaChevronRight onClick={onClick} />
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return <StyledFaChevronLeft onClick={onClick} />
}

const TabPanel = ({data = []}) => {

    const panelWrapperRef = useRef();
    const muiTheme = useTheme();

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        rows: 4,
        responsive: [
            {
                breakpoint: muiTheme.breakpoints.values["sm"],
                settings: {
                    slidesToShow: 2,
                    rows: 6,
                    centerMode: true,
                    centerPadding: '8px'
                }
            },
            {
                breakpoint: muiTheme.breakpoints.values["md"],
                settings: {
                    slidesToShow: 2,
                    rows: 4,
                }
            }
        ]
    };


    return (
        <PanelWrapper ref={panelWrapperRef}>
            {/* <Slider {...settings}> */}
                {_.isArray(data) ? data.map((datum, idx) => (
                    <CardWrapper key={`link_card_${idx}`} panelWidth={getCardWrapperWidth(panelWrapperRef.current, 4)}>
                        <LinkCard {...datum} />
                    </CardWrapper>
                )) : null}
            {/* </Slider> */}
        </PanelWrapper>
    )
}

export default TabPanel;

const LinkCard = ({title="", href=""}) => {
    return (
        <div style={{ width: '100%', height: 20 }}>
            <Link
                accessible
                color="secondary"
                hoverUnderlined
                href={href}
                size="normal"
                stopPropagation
                target="tab"
                theme="AIRASIA_CLASSIC"
                type="normal">
                    {title}
                </Link>
        </div>
    )
}